/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import * as styled from 'styled-components';
import {theme} from 'components/shared/theme';

const {headerAllowance, dangerColor, fontSizeL, fontSizeS} = theme;

export const Error = styled.default.div`
  height: ${window.innerHeight - headerAllowance}px;
  width: 100%;
  display: grid;
  align-content: center;
  justify-content: center;
  text-align: center;
  color: ${dangerColor};
  font-size: ${fontSizeL};
`;

export const ErrorSubMessage = styled.default.div`
  font-size: ${fontSizeS};
  color: ${dangerColor};
`;